<template>
  <div>
    <base-crud
      crudName="Empresas"
      newText="Nova Empresa"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="$store.state.user.access_nivel == 3 ? true : false"
      :enableEdit="true"
      :enableDelete="$store.state.user.access_nivel == 3 ? true : false"
      :enableView="false"
      :dataForm="dataForm"
    />
  </div>
</template>
<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data: function () {
    return {
      table: "companies",
      // pages: [],
      // url: '',
      columns: [
        "id",
        "company_name",
        "company_name_fantasy",
        "email",
        "city",
        "state",
        "actions",
      ],
      tableData: [
        "id",
        "company_name",
        "company_name_fantasy",
        "email",
        "city",
        "state",
      ],
      options: {
        filterable: [
          "id",
          "company_name",
          "company_name_fantasy",
          "email",
          "city",
          "state",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          company_name: "Razão Social",
          company_name_fantasy: "Nome Fantasia",
          email: "E-mail",
          city: "Cidade",
          state: "Estado",
          actions: "Ações",
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "companies/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        company_name: "company_name",
        email: "email",
        city: "city",
        state: "state",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Company/Crud.vue